/**
 * 
 */
cb.define(['common/common_VM.Extend.js'], function (common) {
  var ST_st_transferapply_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
    	var self = this;
    	var detailsModel = viewmodel.get("TransferApplys");
		if(detailsModel){
      //向后台传递行号
      detailsModel.setState('orderField', 'rowno');
			//单元格编辑之前判断该行商品是否启用批次管理和效期管理
			detailsModel.on('rowColChange', function(args) {
				return common.bacthnoAndExpiryDateManage(args, detailsModel);
			});
			//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期
			detailsModel.on('afterCellValueChange', function (data){
				switch (data.cellName) {
					case "product_cCode" : {
						detailsModel.setCellValue(data.rowIndex, 'batchno', null);
						detailsModel.setCellValue(data.rowIndex, 'producedate',  null);
						detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
						break;
					}
				}
			})
		}
      
      viewmodel.on("afterLoadData",function (data) {
      	// 如果是“新增”状态，则单据编码/单据状态 不显示
      	var mode = viewmodel.getParams().mode;
		   
      	if(mode=="add"){
      		//self.queryCentStoreGroup(cb.rest.AppContext.user.storeId,viewmodel);
      	}
      	else if(mode == 'edit'){
      		//self.queryCentStoreGroup(cb.rest.AppContext.user.storeId,viewmodel);
      		//viewmodel.get("btnStoreOut").setVisible(false);
      		//viewmodel.get("btnSubmit").setVisible(false);
      	}
      	else{
      		if(cb.rest.AppContext.user.storeId == data.store){
      			if(data.status == 0){
	      			viewmodel.get("btnStoreOut").setVisible(false);	
	      			viewmodel.get("btnClose").setVisible(false);
	      		
      			}else{
      				viewmodel.get("btnSubmit").setVisible(false);
      				viewmodel.get("btnStoreOut").setVisible(false);
      				viewmodel.get("btnClose").setVisible(false);
      			}
      		}else{
      			if(data.status == 1){
      				
      				viewmodel.get("btnSubmit").setVisible(false);
      				viewmodel.get("btnDelete").setVisible(false);
      				viewmodel.get("btnEdit").setVisible(false);
      			}else{
      				viewmodel.get("btnStoreOut").setVisible(false);
      				viewmodel.get("btnClose").setVisible(false);
      				viewmodel.get("btnSubmit").setVisible(false);
      				viewmodel.get("btnDelete").setVisible(false);
      				viewmodel.get("btnEdit").setVisible(false);
      			}
      		}
      		
      	}
        /*switch(mode){
          case "add":
            viewmodel.get("status").setVisible(false);
            viewmodel.get("btnMovenext").setVisible(false);
            viewmodel.get("btnMoveprev").setVisible(false);
            viewmodel.get("btnDelete").setVisible(false);
            viewmodel.get("btnEdit").setVisible(false);
            viewmodel.get("btnSave").setVisible(true);
            viewmodel.get("btnSaveAndAdd").setVisible(true);
            viewmodel.get("btnAbandon").setVisible(true);
			viewmodel.get("btnAbandonEdit").setVisible(false);
            break;
          case "browse":
            viewmodel.get("status").setVisible(true);
            viewmodel.get("btnMovenext").setVisible(true);
            viewmodel.get("btnMoveprev").setVisible(true);
            viewmodel.get("btnSave").setVisible(true);
            viewmodel.get("btnSaveAndAdd").setVisible(true);
			viewmodel.get("btnAbandon").setVisible(true);
			viewmodel.get("btnAbandonEdit").setVisible(false);
            var status = viewmodel.get("status").getValue();
            if(status != 0){
              //单据状态不是保存态
              viewmodel.get("btnEdit").setVisible(false);
              viewmodel.get("btnDelete").setVisible(false);
            }else{
              viewmodel.get("btnEdit").setVisible(true);
              viewmodel.get("btnDelete").setVisible(true);
            }
            break;
          case "edit":
            viewmodel.get("status").setVisible(true);
            viewmodel.get("btnMovenext").setVisible(true);
            viewmodel.get("btnMoveprev").setVisible(true);
            viewmodel.get("btnDelete").setVisible(true);
            viewmodel.get("btnEdit").setVisible(true);
            viewmodel.get("btnSave").setVisible(true);
            viewmodel.get("btnSaveAndAdd").setVisible(false);
			viewmodel.get("btnAbandon").setVisible(true);

            break;
        }*/
      });
      viewmodel.on("afterEdit",function(){
        viewmodel.get("btnSave").setVisible(true);
        viewmodel.get("btnSaveAndAdd").setVisible(true);
		viewmodel.get("btnAbandon").setVisible(true);
      });
      //保存前校验
		viewmodel.on('beforeSave', function(args) {
			//校验出库数量必须大于零
			var detailsModel = viewmodel.get("TransferApplys");
			var rows = detailsModel.getRows();
			for(var i = 0; i < rows.length ; i ++){
				if(rows[i].quantity <= 0){
					cb.utils.alert("商品出库数量必须大于零！");
					return false;
				}
			}
		
		});		
	},
	// 查询该店铺所有周边门店
	queryCentStoreGroup : function (storeId,viewmodel) {
	  var proxy = cb.rest.DynamicProxy.create({
	  	settle: {
	  		url: "/bill/ref/getCentStoreGroup",
	  		method: "POST" 
	  	} 
	  });
	  var params = {
	    storeId: storeId,
	  };
	  proxy.settle(params, (err, result) => {
	      if (err) {
	        cb.utils.alert(err.message, 'error');
	        return;
	      }
	
	      if(result === undefined || result == "") {
	        cb.utils.alert("未查到该门店周边门店组或周边门店组只有当前门店！", 'error');
	      	//没有周边门店组，查出来为空
	      	//添加门店过滤条件只有周边门店
	      	var conditionStore = {
	      		"isExtend": true,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
				simpleVOs: []
	      	};
			conditionStore.simpleVOs.push({
				field: 'id',
				op: 'in',
				value1: 10010
			});
	      	viewmodel.get('outstore_name').setFilter(conditionStore);

	      } else {
	      	//添加门店过滤条件只有周边门店
	      	var conditionStore = {
	      		"isExtend": true,
				simpleVOs: []
	      	};
			conditionStore.simpleVOs.push({
				field: 'id',
				op: 'in',
				value1: result
			});
	      	viewmodel.get('outstore_name').setFilter(conditionStore);
	      }
      });
	}
  }
  try {
    module.exports = ST_st_transferapply_VM_extend;
  } catch (error) {
  }
  return ST_st_transferapply_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_transferapply_VM.Extend.js